import {resolveChartEntityImageUrl} from '../../../utils/entityAvatarUrl';
import {getReview} from '../ai/chartReviewMeta';
import {ENTITY_CARD_SHAPE_TYPE} from '../tldraw/customShapes/entityCardConstants';

/**
 * Collect unique entities from entity-card shapes on the current tldraw page.
 *
 * @param {import('tldraw').Editor|null|undefined} editor
 * @returns {Array<{
 *   wikidataId: string,
 *   shapeId: string,
 *   label: string,
 *   description: string,
 *   imageUrl: string,
 *   shapeCount: number,
 *   review: object,
 *   x?: number,
 *   y?: number,
 *   w?: number,
 *   h?: number,
 * }>}
 */
export function collectChartEntitiesFromEditor(editor) {
    const shapes = editor?.getCurrentPageShapes?.() || [];
    const byEntityId = new Map();

    for (const shape of shapes) {
        if (shape?.type !== ENTITY_CARD_SHAPE_TYPE || !shape?.props?.wikidataId) continue;

        const wikidataId = shape.props.wikidataId;
        const existing = byEntityId.get(wikidataId);
        if (existing) {
            existing.shapeCount += 1;
            continue;
        }

        byEntityId.set(wikidataId, {
            wikidataId,
            shapeId: shape.id,
            label: shape.props.label || wikidataId,
            description: shape.props.description || '',
            imageUrl: resolveChartEntityImageUrl({
                wikidataId,
                imageUrl: shape.props.imageUrl,
            }),
            shapeCount: 1,
            review: getReview(shape),
            ...finiteNumberFields({
                x: shape.x,
                y: shape.y,
                w: shape.props.w,
                h: shape.props.h,
            }),
        });
    }

    return Array.from(byEntityId.values()).sort((a, b) => (
        a.label.localeCompare(b.label, undefined, {sensitivity: 'base'})
    ));
}

/**
 * @param {Record<string, unknown>} values
 * @returns {Record<string, number>}
 */
function finiteNumberFields(values) {
    const out = {};
    for (const [key, value] of Object.entries(values)) {
        const n = Number(value);
        if (Number.isFinite(n)) {
            out[key] = n;
        }
    }
    return out;
}
